import(/* webpackMode: "eager" */ "/home/runner/work/Invoice/Invoice/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppLink","default","CookieSettingsButton"] */ "/home/runner/work/Invoice/Invoice/src/components/Site/Analytics.js");
